module.exports = __webpack_public_path__ + "img/POÇOS - PASSOS.787bf73b.png";